import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import WhyChooseSection from '../components/WhyChooseSection';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import ServicesListSection from '../components/ServicesListSection';
import SEO, { localBusinessSchema } from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

const HomePage = () => {
  const { isDark } = useTheme();

  return (
    <div className={`min-h-screen ${isDark ? 'bg-neutral-950' : 'bg-white'}`}>
      <SEO 
        title="Car Spray Painting, Crash Repairs & Panel Beating"
        description="JPR Customs is Murray Bridge's premier auto body shop for car spray painting, crash repairs, panel beating, custom paint work, classic car restoration, mechanical repairs and towing. Call +61 417 119 544 for a free quote."
        keywords="spray painting Murray Bridge, car spray painting SA, crash repairs Murray Bridge, panel beating South Australia, auto body shop, collision repairs"
        canonical="/"
        structuredData={localBusinessSchema}
      />
      <Header />
      <main>
        <HeroSection />
        <WhyChooseSection />
        <ServicesSection />
        <AboutSection />
        <ServicesListSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
